'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const RichTextNodeType = {
  heading1: "heading1",
  heading2: "heading2",
  heading3: "heading3",
  heading4: "heading4",
  heading5: "heading5",
  heading6: "heading6",
  paragraph: "paragraph",
  preformatted: "preformatted",
  strong: "strong",
  em: "em",
  listItem: "list-item",
  oListItem: "o-list-item",
  list: "group-list-item",
  oList: "group-o-list-item",
  image: "image",
  embed: "embed",
  hyperlink: "hyperlink",
  label: "label",
  span: "span"
};
const LinkType = {
  Any: "Any",
  Document: "Document",
  Media: "Media",
  Web: "Web"
};
const OEmbedType = {
  Photo: "photo",
  Video: "video",
  Link: "link",
  Rich: "rich"
};

const CustomTypeModelFieldType = {
  Boolean: "Boolean",
  Color: "Color",
  Date: "Date",
  Embed: "Embed",
  GeoPoint: "GeoPoint",
  Group: "Group",
  Image: "Image",
  IntegrationFields: "IntegrationFields",
  Link: "Link",
  Number: "Number",
  Select: "Select",
  Slices: "Slices",
  StructuredText: "StructuredText",
  Text: "Text",
  Timestamp: "Timestamp",
  UID: "UID"
};
const CustomTypeModelLinkSelectType = {
  Document: "document",
  Media: "media"
};
const CustomTypeModelSliceDisplay = {
  List: "list",
  Grid: "grid"
};
const CustomTypeModelSliceType = {
  Slice: "Slice",
  SharedSlice: "SharedSlice"
};

const WebhookType = {
  APIUpdate: "api-update",
  TestTrigger: "test-trigger"
};

const EmbedType = OEmbedType;

exports.CustomTypeModelFieldType = CustomTypeModelFieldType;
exports.CustomTypeModelLinkSelectType = CustomTypeModelLinkSelectType;
exports.CustomTypeModelSliceDisplay = CustomTypeModelSliceDisplay;
exports.CustomTypeModelSliceType = CustomTypeModelSliceType;
exports.EmbedType = EmbedType;
exports.LinkType = LinkType;
exports.OEmbedType = OEmbedType;
exports.RichTextNodeType = RichTextNodeType;
exports.WebhookType = WebhookType;
//# sourceMappingURL=index.cjs.map
